/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
export var StyledTableWrapper = styled('div')(function () {
  return {
    '&.EmbersTable-root': {
      '.EmbersTableTopControls-root': {
        margin: '8px 0'
      },
      '.EmbersTableBottomControls-root': {
        margin: '24px 0'
      }
    }
  };
});